import { useState } from "react";

function TableList({ data, label }) {
    const [tooltip, setTooltip] = useState(null);

    const total = data.reduce((sum, item) => sum + item[label], 0);

    return (
        <div className="relative space-y-1">
            {data.map((item, index) => {
                const percent = ((item[label] / total) * 100).toFixed(1);
                return (
                    <div
                        key={item._id}
                        className="flex justify-between items-center"
                        onMouseEnter={(e) => {
                            const rect = e.currentTarget.getBoundingClientRect();
                            setTooltip({
                                content: {
                                    title: item.displayName || item._id,
                                    value: item[label],
                                    label,
                                    percent,
                                },
                                top: rect.bottom + window.scrollY,
                                left: rect.left + window.scrollX,
                            });
                        }}
                        onMouseLeave={() => setTooltip(null)}
                    >
                        <span className="capitalize truncate w-32 text-gray-700 cursor-default">
                            {item.displayName || item._id}
                        </span>

                        <div className="flex-1 mx-2 bg-gray-200 rounded-full h-1">
                            <div
                                className="bg-primary-600 h-1 rounded-full"
                                style={{ width: `${percent}%` }}
                            />
                        </div>

                        <span className="min-w-[24px] text-right font-medium text-gray-800">
                            {item[label]}
                        </span>
                    </div>
                );
            })}

            {tooltip && (
                <div
                    className="fixed z-50 bg-white border border-gray-200 shadow-xl rounded-xl p-3 text-sm w-60"
                    style={{
                        top: tooltip.top + 8,
                        left: tooltip.left,
                    }}
                >
                    <div className="font-semibold text-primary-600 mb-1">
                        {tooltip.content.title}
                    </div>
                    <div className="flex justify-between text-gray-600">
                        <span className="capitalize">{tooltip.content.label}</span>
                        <span className="font-semibold text-gray-800">
                            {tooltip.content.value}
                        </span>
                    </div>
                    <div className="mt-1 text-right text-xs text-gray-500">
                        {tooltip.content.percent}% of total
                    </div>
                </div>
            )}
        </div>
    );
}

function LoadingList() {
    return (
        <div className="space-y-1">
            {[...Array(4)].map((_, index) => (
                <div key={index} className="flex justify-between items-center">
                    <div className="w-32 h-4 bg-gray-200 rounded animate-pulse" />
                    <div className="flex-1 mx-2 h-1 bg-gray-200 rounded-full animate-pulse" />
                    <div className="w-6 h-4 bg-gray-200 rounded animate-pulse" />
                </div>
            ))}
        </div>
    );
}

export default function CardSummary({ title, data, label, loading }) {
    return (
        <div className="border rounded-lg p-4 shadow-sm bg-white text-sm">
            <h2 className="font-semibold mb-3 text-primary-600">{title}</h2>
            {loading ? <LoadingList /> : <TableList data={data} label={label} />}
        </div>
    );
}